module.exports = __webpack_public_path__ + "static/media/michaelHeimert.b6ec1195.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/michaelHeimert.jpg
// module id = 1376
// module chunks = 1